import { render } from "./PatientConsultationService.vue?vue&type=template&id=2f9b8714&scoped=true"
import script from "./PatientConsultationService.vue?vue&type=script&lang=js"
export * from "./PatientConsultationService.vue?vue&type=script&lang=js"

import "./PatientConsultationService.vue?vue&type=style&index=0&id=2f9b8714&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f9b8714"]])

export default __exports__